import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import CollapseIcon from '../../../../images/collapse copy 5.png'
import ExpandIcon from '../../../../images/expand copy 5.png'

class Servitutt extends Component {
    state = {
        isOpened: false,
        isContextMenuOpen: false
    }

    toggleServitutt = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    toggleContextMenu = (event) => {
        event.stopPropagation()
        this.setState({isContextMenuOpen: !this.state.isContextMenuOpen})
    }

    render() {
        const { t } = this.props        
        var servitutt = this.props.servitutt
        var text = servitutt.tekst == null ? "" : servitutt.tekst.join('<br>')

        return (
            <li>
                <div className="section-header subsubsection" onClick={this.toggleServitutt}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{servitutt.dokumentnavn} {servitutt.dokumentaar}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('dokumentaar')}</div>
                            <div className="value">{servitutt.dokumentaar}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('dokumentnummer')}</div>
                            <div className="value">{servitutt.dokumentnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('dokumentnavn')}</div>
                            <div className="value">{servitutt.dokumentnavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('tekst')}</div>
                            <div className="value" dangerouslySetInnerHTML={{__html: text}}></div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Servitutt)